export const BOOK_FEED = [
    /**
     * Preview Book Feed Schema
     * 'title': 'book title'
     * 'subtitle': 'book subtitle'
     * 'rank': 'book ranking'
     * 'desc': 'book description -- around 50-100 words describing book'
     * 'img_src': 'Image preview filename - remote'
     * 'img_info': '[Optional] Image preview info'
     */
     {
        'title': 'Locke & Key, Vol. 1',
        'subtitle': 'Written by: Joe Hill, Illustrated by: Gabriel Rodríguez',
        'desc_1': `🪄🪄🪄🪄🪄`,
        'desc_2': `🧟‍♀️🧟‍♀️🧟‍♀️🧟‍♀️`,
        'desc_3': `🗝🗝🗝🗝🗝`,
        'img_src': 'https://images-na.ssl-images-amazon.com/images/I/91ok9q8rY8L.jpg',
        'img_info': null,
    },
    {
        'title': '20th Century Boys',
        'subtitle': 'Written by: Naoki Urasawa',
        'desc_1': `👁👁👁👁`,
        'desc_2': `🏃‍♂️🏃‍♂️🏃‍♂️`,
        'desc_3': `🐸🐸🐸🐸🐸`,
        'img_src': 'https://images-na.ssl-images-amazon.com/images/I/91F15VTNFFL.jpg',
        'img_info': null,
    },
]